import React, { Component } from 'react';
import { connect } from 'react-redux';
import LoginView from './Login.view';
import config from '../../../../config';

export class LoginContainer extends Component {
  constructor(props){
    super(props);
    this.state = {
      loginFormState: {
        data: {
          username: config.mockdata.loginUsername,
          password: config.mockdata.loginPassword
        }
      }
    };
    this.submitLogin = this.submitLogin.bind(this);
    this.onFormUpdate = this.onFormUpdate.bind(this);
  }

  componentDidMount(){
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_LOGIN_DATA'
    });
  }

  submitLogin({data}) {
    const { dispatch, history, location } = this.props;
    dispatch({
      type: 'SUBMIT_LOGIN',
      payload: data,
      meta: {
        history: history,
        redirectUrl: location.query.redirectUrl || '/'
      }
    });
  }

  onFormUpdate(loginFormState, action) {
    this.setState({
      loginFormState
    });
  }


  render() {
    return (
      <LoginView
        {...this.props}
        submitLogin={this.submitLogin}
        onFormUpdate={this.onFormUpdate}
        loginFormState={this.state.loginFormState}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    loginFormLoading: state.loaders.loginForm
  };
}

export default connect(mapStateToProps)(LoginContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Login/Login.container.js